import { render, staticRenderFns } from "./businessArea.vue?vue&type=template&id=7f8e7d1e&scoped=true&"
import script from "./businessArea.vue?vue&type=script&lang=js&"
export * from "./businessArea.vue?vue&type=script&lang=js&"
import style0 from "./businessArea.vue?vue&type=style&index=0&id=7f8e7d1e&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8e7d1e",
  null
  
)

export default component.exports